var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record-materials-modal-history__container"},_vm._l((_vm.recordMaterialsModal.history),function(register,index){return _c('material-history-card',{key:("register-" + index),attrs:{"register":register}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }